export default __webpack_public_path__ + "images/685fd72221934d67a5afa26c65143863.webp";